
import consumer from "./consumer"
import * as ActionCable from '@rails/actioncable'

ActionCable.logger.enabled = false

consumer.subscriptions.create({
  channel: "DownloadsChannel"
}, {

  received(data) {
    this.appendLine(data)
  },

  appendLine(data) {
    const html = this.createLine(data)
    // Select the parent element with the ID 'flash-messages'
    var flashMessages = document.getElementById('flash-messages');

    // Check if there is at least one child with the class 'alert-info'
    var hasAlertChild = flashMessages.querySelector('.alert') !== null;
    var downloadElement = document.getElementById(`download_${data.download_id}`);

    if (!!downloadElement) {
      // replace alert
      downloadElement.outerHTML = html;
    } else if (hasAlertChild) {
      // append alert
      flashMessages.insertAdjacentHTML("beforeend", html);
    } else {
      // insert
      flashMessages.innerHTML = html;
    }
  },

  createLine(data) {
    if (!!data.download_link) {
      if (!data.alert) {
        data.alert = 'info'
      }

      return `
        <div class="alert alert-${data.alert} alert-dismissible fade show mb-0" id=download_${data.download_id} role='alert'>
          ${data.message} - <a href=${data.download_link}>Download Now</a>
          <button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button>
        </div>
      `
    } else {
      return `
        <div class="alert alert-${data.alert} alert-dismissible fade show mb-0" id=download_${data.download_id} role='alert'>
          ${data.message}
          <button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button>
        </div>
      `
    }

  }
});

